import type TriggerEngine from "../../TriggerEngine";
import type { EventSourceResult } from "../../TriggerEngine.interfaces";
import type { IWatchTemplate } from "../../ScenesManager";

export const wireSceneEvents = (engine: TriggerEngine): EventSourceResult => {
  let currentId = engine.Radio.ScenesManager.getModel()?.id;
  const onSceneChanged: IWatchTemplate = ({ currentModel, eventContext }) => {
    const nextId = currentModel?.id;
    if (nextId === currentId) return;
    const previousId = currentId;
    currentId = nextId;
    // Initial scene hydration and edits are not scene switches.
    if (!previousId || !nextId) return;
    if (eventContext) void engine.fireEvent("scene_switched", undefined, eventContext);
    else void engine.fireEvent("scene_switched");
  };

  engine.Radio.ScenesManager.watch("model", onSceneChanged);

  return {
    unsubscribers: [
      () => engine.Radio.ScenesManager.unwatch("model", onSceneChanged),
    ],
  };
};
